<script setup>
import { ref, onMounted } from "vue";

import AttachmentItem from "@/shared/ui/upload/AttachmentItem.vue";
import { getDocumentListNotarial } from "@/entities/transaction";
import { extractItems } from "@/shared/serviceResponse";
import { downloadFileSecure } from "@/shared/lib/downloadFile";
import { Spinner } from "@/shared/ui/spinner";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const loading = ref(false);
const documentList = ref([]);

async function fetchDocuments() {
  loading.value = true;
  try {
    const { success, payload } = await getDocumentListNotarial(props.uuid);
    if (success) {
      documentList.value = extractItems(payload);
    }
  } finally {
    loading.value = false;
  }
}

async function downloadFile(file) {
  await downloadFileSecure(file);
}

onMounted(() => {
  fetchDocuments();
});
</script>

<template>
  <div class="template">
    <div class="block">
      <div class="attachments">
        <div v-if="loading" class="flex justify-center items-center py-8">
          <Spinner size="sm" />
        </div>
        <div v-else-if="!documentList.length" class="empty">
          <span class="text">{{ $t("Вложения отсутствуют") }}</span>
        </div>
        <div v-else class="list">
          <AttachmentItem
            v-for="file in documentList"
            :key="file.uuid"
            :file="file"
            :actions="['download']"
            @download="downloadFile(file)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.template {
  @apply flex h-full w-full overflow-x-hidden gap-5;

  .block {
    @apply flex flex-col w-1/2 h-full  rounded-2xl gap-6 overflow-hidden;
    background-color: hsl(var(--background));
    min-height: 600px !important;
    box-shadow: 0 1px 1px -0.5px rgba(0, 0, 0, 0.03),
      0 3px 3px -1.5px rgba(0, 0, 0, 0.03),
      0 20px 20px -12px rgba(0, 0, 0, 0.03);
  }
}

@media (max-width: 900px) {
  .template {
    @apply flex flex-col;

    .block {
      @apply w-full;
    }
  }
}

.attachments {
  @apply w-full bg-card rounded-2xl p-4;

  .list {
    @apply flex flex-col gap-3;
  }

  .empty {
    @apply w-full flex items-center justify-center py-8;
  }

  .text {
    @apply text-sm text-muted-foreground;
  }
}
</style>
